import { Component, OnInit } from '@angular/core';
import { MarketplaceService } from '@fgb/core';
import { firstValueFrom } from 'rxjs';
import { Populations } from 'src/app/shared/utilities/populations';
@Component({
  selector: 'fgb-events-page',
  templateUrl: './events-page.component.html',
  styleUrls: ['./events-page.component.scss'],
})
export class EventsPageComponent implements OnInit {
  constructor(private marketplaceService: MarketplaceService) {}
  populations = Populations;
  ngOnInit() {
    firstValueFrom(this.marketplaceService.fetchMarketplaceItems());
  }
}
